module.exports = __webpack_public_path__ + "static/img/join_1.a1f749b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/join_1.jpg
// module id = JI9u
// module chunks = 0